const links={
    answerTest:{
        login:"/panel/test",
        test:"/panel/answer",
        testsGroup:"/panel/answers",
        loginGroup:"/panel/tests",
    },
    labsList:{
            home:"/panel/",
            allKindTests:"/panel/kind-test",
    }


}
export default links;